<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <div style="margin: 20px 0;">
                    <component-query :queryMode="playerQueryMode" @usersData="getUsersData"></component-query>
                </div>

                <el-table :data="playerData" border style="width: 50%;margin-bottom: 20px;"
                          @current-change="handlePlayerDataChange" highlight-current-row>
                    <el-table-column prop="id" label="用户id"  width="120"></el-table-column>
                    <el-table-column prop="server" label="游戏服编号" width="120"></el-table-column>
                    <el-table-column prop="email" label="sid" width="120"></el-table-column>
                    <el-table-column prop="channel" label="渠道" width="120"></el-table-column>
                    <el-table-column prop="nick" label="昵称"></el-table-column>
                    <el-table-column prop="level" label="等级"></el-table-column>
                    <el-table-column label="禁言状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.silence == 0">正常</span>
                            <span v-if="scope.row.silence == 1">禁言</span>
                            <span v-if="scope.row.silence == 2">伪禁言</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="封号状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.block == 0">正常</span>
                            <span v-if="scope.row.block == 1">后台封禁</span>
                            <span v-if="scope.row.block == 2">系统封禁</span>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="query-panel">
                    <el-form  label-suffix=":" inline>
                        <el-form-item label='内购项'>
                            <el-select v-model="iapFindBO.configId" placeholder='选择内购项'>
                                <el-option v-for="item in payOptions" :key="item.id" :label="item.id + '-' + $t(item.name)" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='订单状态'>
                            <el-select v-model="iapFindBO.dealTag" placeholder='选择订单状态'>
                                <el-option v-for="item in dealTagOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='玩家下单时间'>
                            <el-date-picker v-model="dateTime" type="datetimerange" range-separator='至'
                                start-placeholder='开始时间' end-placeholder='结束时间' value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="findCharges()">查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <el-table :data="dataHandled" border style="margin-top:20px;width: 100%">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-descriptions title="" :column="1" size="medium" border>
                                <el-descriptions-item label="充值回调信息">
                                    <div>{{scope.row.chargeCallback}}</div>
                                </el-descriptions-item>
                                <el-descriptions-item label="游戏端响应消息">
                                    <div>{{scope.row.ntResult}}</div>
                                </el-descriptions-item>
                            </el-descriptions>
                        </template>
                    </el-table-column>
                    <el-table-column prop="gameOrderNo" label='订单号'>
                    </el-table-column>
                    <el-table-column prop="email" label='sid'>
                    </el-table-column>
                    <el-table-column prop="userId" label='玩家id'>
                    </el-table-column>
                    <el-table-column prop="server" label='服务器id'>
                    </el-table-column>
                    <el-table-column prop="channel" label='渠道'>
                    </el-table-column>
                    <el-table-column prop="publisher" label='渠道标志'>
                    </el-table-column>
                    <el-table-column prop="identifier" label='内购项'>
                        <template slot-scope="scope">
                            <div v-for="item in payOptions" v-if="item.id == scope.row.identifier">
                                {{item.id}}({{$t(item.name)}})
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unifiedIp" label='下单IP'>
                    </el-table-column>
                    <el-table-column label='下单时间'>
                        <template slot-scope="scope">
                            {{Util.formatDate(scope.row.gmtCreate)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="thirdNo" label='第三方订单号'>
                    </el-table-column>
                    <el-table-column prop="notifyAmount" label='返回的金额'>
                    </el-table-column>
                    <el-table-column prop="chargeAmount" label='发起时的配置金额(单位：分)'>
                    </el-table-column>
                    <el-table-column prop="finalReward" label='最终奖励'>
                    </el-table-column>
                    <el-table-column prop="payStatus" label='订单状态'>
                        <template slot-scope="scope">
                            <div v-for="item in dealTagOptions" v-if="item.value == scope.row.payStatus">
                                <el-tag type="success">{{item.label}}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="duplicateTag" label='重复付款标识'>
                    </el-table-column>
                    <el-table-column label='订单操作'>
                        <template slot-scope="scope">
                             <el-button v-if="scope.row.payStatus == 0" @click="repushOrder(scope.row)">重推订单</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                        layout="total, prev, pager, next, jumper" :total="totalRow">
                    </el-pagination>
                </div>
            </section>
        </div>
    </el-card>
</template>

<script>
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import {
        mapState
    } from 'vuex';
    import gameApi from '../../service/game_api'
    import confApi from '../../service/conf_api'
    import componentServer from '../../components/component_server'
    import componentQuery from '../../components/component_query'
    import utils from '../../lib/utils'
    import activityApi from "../../service/activity_api";
    export default {
        name: "logs",
        data() {
            return {
                title: this.$route.meta.title,
                playerQueryMode: ['mode_long_id','mode_short_id','mode_nick','mode_email'],
                payOptions: [],
                Util: utils,
                playerData: [],

                dateTime: '',
                iapFindBO: {
                    uri: '',
                    uid: '',
                    dealTag: '',
                    configId: '',
                    stime: '',
                    etime: ''
                },

                dealTagOptions: [
                    {
                        value: '-2',
                        label: '全部状态'
                    },
                    {
                        value: '-1',
                        label: '订单预创建'
                    },
                    {
                        value: '0',
                        label: '已下单'
                    },
                    {
                        value: '2',
                        label: '已发货'
                    },
                    {
                        value: '3',
                        label: '玩家退款'
                    }
                ],

                optionMap:{
                    '0':this.$t("reward_editor.39"),
                    '1':this.$t("reward_editor.40"),
                    '2':this.$t("reward_editor.41"),
                    '3':this.$t("reward_editor.42"),
                    '4':this.$t("reward_editor.43"),
                    '5':'约束性道具',
                    '6':this.$t("reward_editor.44"),
                    '7':'战纹',
                    '8':this.$t("reward_editor.46"),
                    '9':this.$t("reward_editor.47"),
                    '10':'回复类道具',
                    '11':'头像',
                    '12':'头像框',
                    '13':'宝箱',
                    '14':'皮肤',
                    '15':'时效类道具',
                    '16':'部落头像',
                    '17':'起源盘',
                    '18':'自选元核',
                    '19':'进化光谱',
                    '20':'聊天框',
                    '21':'战斗框',
                    '22':'元核碎片',
                    '23':'元核髓',
                },
                optionValue: '0',
                count1: '',
                count2: '',
                countSwitch: false,
                rate: 0.1,
                value: '',
                emblemEntryConfigs: [],
                emblemLevel: 1,
                emblemStage: 0,
                emblemQuality: 1,
                emblemFate:0,
                emblemFateCustomizeTags:[],
                emblemFateCustomize:100,
                emblemMainProperty: 1,
                emblemFateProperty: 51,
                editEmblemEntries:[
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ],
            }
        },
        created() {
            this.getReadData();
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        methods: {
            getUsersData(val) {
                this.playerData = val;
            },
            getReadData() {
                let self = this;
                confApi.getReadData({
                    token: this.token,
                    tableName: 'iap_buy_config'
                }).then(res => {
                    self.payOptions.push({
                        id: 0,
                        name: '全部'
                    })
                    res.forEach(item => {
                        if (item.product_id !== '/') {
                            self.payOptions.push(item);
                        }
                    })
                })
            },

            handlePlayerDataChange(currentRow) {
                if (currentRow !== undefined) {
                    this.iapFindBO.uri = currentRow.uri;
                    this.iapFindBO.uid = currentRow.id;
                }
            },

            // 玩家充值查询
            findCharges() {
                this.iapFindBO.stime = this.dateTime[0];
                this.iapFindBO.etime = this.dateTime[1];
                if (this.iapFindBO.configId === '' || this.iapFindBO.dealTag === ''){
                    this.$message({
                        type: 'error',
                        message: '内购项和订单状态不能为空！！！'
                    });
                    return;
                }

                gameApi.findCharges({
                    token: this.token,
                    iapFindBO: this.iapFindBO
                }).then(res => {
                    res.content.iaps.forEach(item => {
                        if (item.finalReward !== '' && item.finalReward !== undefined) {
                            item.finalReward = item.finalReward + (item.finalReward?'(':'') + this.formatterRewardsToCN(item.finalReward) + (item.finalReward?')':'');
                        }
                    })
                    this.dataHandled = res.content.iaps;
                    this.totalRow = res.content.iaps.length;
                })
            },

            formatterRewardsToCN(row) {
                var arr = row.split(',');
                var result = '';
                arr.forEach(item => {
                    if (item !== '') {
                        this.resolveRewardStr(item);

                        // let optionValueCN = this.optionMap[this.optionValue];
                        let idCn = this.getIdCn(this.optionValue,this.value);
                        let finalCount = '';
                        if (this.countSwitch) {
                            finalCount = this.count1 + "-" + this.count2;
                        } else {
                            finalCount = this.count1
                        }
                        let finalContentCN = idCn + "_" + finalCount;
                        result = result + (result?',':'') + finalContentCN;
                    }

                })
                return result;
            },
            resolveRewardStr(str){
                let self = this;

                if (str == '') {
                    self.countSwitch = false;
                    self.rateSwitch = false;
                    self.isDetail = false;
                    self.count1 = 1;
                    self.count2 = 1;
                    self.rate = 0.1;
                    self.emblemLevel = 1;
                    self.emblemStage = 0;
                    self.emblemQuality = 1;
                    self.emblemMainProperty = 1;
                    self.emblemFate = 0;
                    self.emblemFateCustomize = 100;
                    self.emblemFateProperty = 51;

                    self.editEmblemEntries = [
                        {
                            entry:[3, 0],
                            quality:0,
                            active:true
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                    ]
                }

                let rewardArray = str.toString().split("_");

                for (let index = 0; index < rewardArray.length; index++) {
                    const element = rewardArray[index];
                    switch (index) {
                        case 0:
                            // let bigTypeArry = element.split("$");
                            // //大类
                            // self.optionValue = bigTypeArry[0];
                            // //identify
                            // self.value = parseInt(bigTypeArry[1]);
                            self.value = element;

                            if (self.value == 50001) {
                                self.emblemRandomByQuality = false;
                            } else {
                                self.emblemRandomByQuality = true;
                            }
                            break;
                        case 1:
                            //数量
                            let countArry = element.split("-");
                            if(countArry.length>1){
                                self.countSwitch = true;
                                self.count1 = countArry[0];
                                let rateAndCount = countArry[1].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count2 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count2 = countArry[1];
                                }
                            }else{
                                self.countSwitch = false;

                                let rateAndCount = countArry[0].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count1 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count1 = countArry[0];
                                }
                            }
                            break;
                        case 2:
                            //等级
                            self.emblemLevel = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveQuality = parseInt(element);
                            }
                            break;
                        case 3:
                            //阶段
                            self.emblemStage = parseInt(element);

                            if (self.optionValue == '7') {
                                if (element) {
                                    self.warGrooveChannelSwitch = true;
                                    self.warGrooveChannelUp = parseInt(element);
                                } else {
                                    self.warGrooveChannelSwitch = false;
                                }
                            }
                            break;
                        case 4:
                            //品质
                            self.emblemQuality = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelDown = parseInt(element);
                            }
                            break;
                        case 5:
                            //宿命
                            let fateArray = element.split("#");
                            self.emblemFate = 3;
                            if(fateArray.length>1){
                                for (let i = 0; i < fateArray.length; i++) {
                                    const element = fateArray[i];
                                    let item = fateArray.splice("@");
                                    self.emblemFateCustomizeTags[i] = {id:parseInt(item[0]),chance:parseInt(item[1])}
                                }
                            }else{
                                if(element>0){
                                    self.emblemFate = 2;
                                    self.emblemFateProperty = parseInt(element);
                                }else{
                                    self.emblemFate = 0;
                                }
                            }

                            if (self.optionValue == '7') {
                                self.warGrooveChannelLeft = parseInt(element);
                            }

                            break;
                        case 6:
                            //宿命自定义概率
                            self.emblemFateCustomize = parseInt(element*100);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelRight = parseInt(element);
                            }
                            break;
                        case 7:
                            //主属性
                            self.emblemMainProperty = parseInt(element);
                            break;
                        case 8:
                            //词条属性
                            let entryArray = element.split("#");
                            for (let index = 0; index < entryArray.length; index++) {
                                const entryItem = entryArray[index];
                                let current = self.editEmblemEntries[index];

                                self.emblemEntryConfigs.forEach(item => {
                                    item.children.forEach(iitem => {
                                        if (iitem.value == entryArray[index].split('@')[0]&&entryArray[index].split('@').length>1) {
                                            self.editEmblemEntries[index].entry = [item.value,iitem.value];
                                            self.editEmblemEntries[index].active = true;
                                        } else {
                                            self.editEmblemEntries[index].active = false;
                                        }
                                    })
                                })

                                self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                            }

                            let countAndEntry = entryArray[entryArray.length-1].split('|');
                            if (countAndEntry.length>1) {
                                self.rateSwitch = true;
                                self.rate = countAndEntry[1];
                            } else {
                                self.rateSwitch = false;
                            }
                            break;
                        default:
                            break;
                    }
                }
            },

            getIdCn(optionValue,id){
                let self = this;
                if(optionValue == "0" || optionValue == "3" || optionValue == "4" || optionValue == "5" || optionValue == "9" || optionValue == "10" || optionValue == "11" || optionValue == "12" || optionValue == "13" || optionValue == "14" || optionValue == "15"){
                    //道具
                    return self.$t('propConfigName_'+id);
                }else if(optionValue == "1"){
                    //怪兽
                    return self.$t('monsterName_' + id);
                }else if(optionValue == "2"){
                    //怪兽碎片
                    return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
                }else if(optionValue == "6"){
                    //怪兽觉醒水晶
                    return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
                }else if(optionValue == "8"){
                    //怪兽觉醒水晶碎片
                    return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
                }else if(optionValue == "7"){
                    //战纹
                    return self.$t('warGrooveConfigName_' + id);
                }
            },
            repushOrder(rowData){
                let uri = this.iapFindBO.uri;
                this.$confirm("此操作会对订单【"+ rowData.gameOrderNo +"】进行重推", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //当前时间可开启绝版UP活动，当前活动无法开启
                    gameApi.repushOrder({
                        token: this.token,
                        repushForm: {
                            uri:uri,
                            id: rowData.id,
                        }
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '订单重推成功'
                        })
                    })
                })
            }
        },
        components: {
            componentServer,
            componentQuery
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/players/query_player_pay.vue